module.exports = __webpack_public_path__ + "static/Highlight0-fa3824d9941d15cc2b0c651b115c88df.png";